import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { toast } from "react-toastify";

import { PageLayout } from "../../layouts/PageLayout";
import { CardLayout, EmptyState, PageHeader } from "../../components/v3";
import { ToolReportForm, ToolReportResults } from "../../components/report";

export const ToolReport = () => {
  const [loading, setLoading] = useState(false);
  const [reportFilters, setReportFilters] = useState(null);
  const [reportData, setReportData] = useState({});
  const [activeTab, setActiveTab] = useState("summary");
  const [paginationState, setPaginationState] = useState({ page: 0, pageSize: 10 });

  useEffect(() => {
    setReportData({});
  }, [activeTab]);

  const fetchData = async (filters, { onError } = {}) => {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 900));

      // ---- Dummy data ----
      const dummyRows =
        activeTab === "summary"
          ? [
              {
                toolName: "Hammer",
                totalIssued: 25,
                totalReturned: 18,
                netUsed: 7,
                currentBalance: 43,
              },
              {
                toolName: "Drill Machine",
                totalIssued: 12,
                totalReturned: 10,
                netUsed: 2,
                currentBalance: 8,
              },
              {
                toolName: "Concrete Mixer",
                totalIssued: 5,
                totalReturned: 3,
                netUsed: 2,
                currentBalance: 4,
              },
            ]
          : [
              {
                date: "2025-08-01",
                toolName: "Hammer",
                projectName: "Tower A",
                quantity: 5,
                currentBalance: 45,
              },
              {
                date: "2025-08-02",
                toolName: "Hammer",
                projectName: "Tower A",
                quantity: 2,
                currentBalance: 43,
              },
              {
                date: "2025-08-02",
                toolName: "Drill Machine",
                projectName: "Block B",
                quantity: 3,
                currentBalance: 10,
              },
              {
                date: "2025-08-03",
                toolName: "Drill Machine",
                projectName: "Block B",
                quantity: 1,
                currentBalance: 9,
              },
              {
                date: "2025-08-04",
                toolName: "Concrete Mixer",
                projectName: "Villa Project",
                quantity: 1,
                currentBalance: 5,
              },
              {
                date: "2025-08-05",
                toolName: "Concrete Mixer",
                projectName: "Villa Project",
                quantity: 1,
                currentBalance: 4,
              },
            ];

      const response = {
        rows: dummyRows,
        count: dummyRows.length,
      };

      setReportData(response);
    } catch (error) {
      onError?.();
      toast.error("Failed to generate report");
      console.error("Error fetching tool report:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleGenerate = (filters, { onError } = {}) => {
    setLoading(true);
    setReportData({});
    setReportFilters(filters);
    setPaginationState({ page: 0, pageSize: 10 });
    fetchData(
      {
        ...filters,
        page: 1,
        limit: 10,
      },
      { onError },
    );
  };

  const handlePaginationChange = (model) => {
    setPaginationState(model);
    fetchData({
      ...reportFilters,
      page: model.page + 1,
      limit: model.pageSize,
    });
  };

  const reportType = [
    { label: "Summary", onClick: () => setActiveTab("summary") },
    { label: "Details", onClick: () => setActiveTab("details") },
  ];

  return (
    <PageLayout>
      {/* header section */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader
          // title
          title="Tool Report"
          chipItems={reportType}
          activeTab={activeTab}
        />
      </Box>

      {/* form section */}
      <Box sx={{ mt: -7, zIndex: 2, position: "relative" }}>
        <ToolReportForm
          reportType={activeTab === "summary" ? "summary" : "detailed"}
          handleClear={() => setReportData({})}
          onGenerate={handleGenerate}
        />
      </Box>

      {/* results section */}
      {!loading &&
        reportData?.count !== undefined &&
        (reportData?.count > 0 ? (
          <ToolReportResults
            reportType={activeTab === "summary" ? "summary" : "detailed"}
            data={reportData}
            loading={loading}
            paginationState={paginationState}
            handlePaginationChange={handlePaginationChange}
          />
        ) : (
          <CardLayout>
            <EmptyState title="No Data Found" subtitle="No report found for selected filters!" />
          </CardLayout>
        ))}
    </PageLayout>
  );
};
